/* eslint-disable */
export class UpdateAcquisitionStatusRequest {
  acquisitionStatusCode: string = "Client";
  acquisitionSubstatusCode?: string;
}